import { udex } from '../../../scripts/dom-builder.js';
import checkIsFromSAP from '../../../scripts/utils/sap-utils.js';

export function rerenderFirstColumnForSAP(tableWrapper) {
  const isSap = checkIsFromSAP();
  if (!isSap) {
    return;
  }

  const rows = tableWrapper.querySelectorAll('udex-table-row');

  rows.forEach((row) => {
    const firstCell = row.querySelector('udex-table-cell:first-child');
    if (!firstCell) {
      return;
    }

    const raw = firstCell.textContent.trim();
    const match = raw.match(/https?:\/\/\S+/);

    if (match) {
      const url = match[0];

      const link = udex(
        'link',
        { href: url, target: '_blank' },
        raw.replace(url, '').trim() || url,
      );

      firstCell.replaceChildren(link);
    }
  });
}
